export const resetFavoriteMessageStatus = (reset) => {
  return {
    type: 'RESET_FAVORITE_MESSAGES_STATUS',
    payload: reset,
  }
}

export const favoriteMessagesError = (error) => {
  return {
    type: 'FAVORITE_MESSAGES_ERROR',
    payload: error,
  }
}

export const getFavoriteMessages = (data) => {
  return {
    type: 'GET_FAVORITE_MESSAGES',
    payload: data,
  }
}

export const setFavoriteMessages = (data) => {
  return {
    type: 'SET_FAVORITE_MESSAGES',
    payload: data,
  }
}
export const updateFavoriteMessages = (data) => {
  return {
    type: 'UPDATE_FAVORITE_MESSAGES',
    payload: data,
  }
}
